enum RelationshipType {
  Customer = "CUSTOMER",
  Contractor = "CONTRACTOR",
  Supplier = "SUPPLIER",
  Other = "OTHER",
}

export default RelationshipType;
